import { state } from "../context/store";
import closePopups from "./closePopups";

const resetNumber = (e) => {
  console.log("resetting race number");
  state.current.choices.raceNumber.selected = {
    mode: "none",
    name: "",
    outlineName: "",
    number: "",
    hex: "#eee",
    outlineHex: "#111",
    font: "old-english.ttf",
  };
  state.current.status.confirmRemoveNumber = false;
  closePopups(e);
};

export default resetNumber;
